<script setup lang="ts">
const items = [
  {
    title: 'Tambah Anggota Tim Langsung dari Dashboard',
    icon: 'material-symbols:person-add-outline'
  },
  {
    title: 'Atur Hak Akses & Izin Sesuai Peran',
    icon: 'material-symbols:manage-accounts-outline'
  },
  {
    title: 'Pantau Aktivitas Staff Real-Time',
    icon: 'material-symbols:visibility-outline'
  },
  {
    title: 'Analisis Performa Harian dari Laporan Otomatis',
    icon: 'material-symbols:fact-check-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Bagi Peran, Amankan Akses, Pantau Kinerja"
        description="Semua terintegrasi dengan fitur COD, RMS dan Laporan Keuangan KiriminAja. Satu dashboard untuk semua operasional"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-4">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
        />
      </div>
    </UiContainer>
  </section>
</template>
